module.exports = __webpack_public_path__ + "media/images/components/landing_pages/reassurance_cards/accessible-7af7d4f181919146ac5cb6842852047f.png";